import { render, staticRenderFns } from "./WhatsappCoexSettings.vue?vue&type=template&id=4cc06ddf&scoped=true&"
import script from "./WhatsappCoexSettings.vue?vue&type=script&lang=js&"
export * from "./WhatsappCoexSettings.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappCoexSettings.vue?vue&type=style&index=0&id=4cc06ddf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc06ddf",
  null
  
)

export default component.exports